import React, { useState } from 'react';
import { toast } from 'sonner';
import { useLanguage } from '../contexts/LanguageContext';
import {
  Header,
  Hero,
  About,
  Services,
  Team,
  FAQ,
  Booking,
  Contact,
  Footer,
  WhatsAppButton
} from '../components/home';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const Home = () => {
  const { language, changeLanguage, t } = useLanguage();
  
  const [contactForm, setContactForm] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  
  const [bookingForm, setBookingForm] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    disputeType: '',
    preferredDay: '',
    preferredTime: '',
    alternativeSlots: '',
    message: ''
  });

  const [isSubmittingContact, setIsSubmittingContact] = useState(false);
  const [isSubmittingBooking, setIsSubmittingBooking] = useState(false);

  const handleContactSubmit = async (e) => {
    e.preventDefault();
    setIsSubmittingContact(true);
    
    try {
      const response = await fetch(`${API_URL}/api/contact`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(contactForm)
      });
      
      if (!response.ok) {
        throw new Error('Failed to submit contact form');
      }
      
      const data = await response.json();
      toast.success(t.toast.contactSuccess);
      setContactForm({ name: '', email: '', phone: '', message: '' });
    } catch (error) {
      toast.error(t.toast.error);
    } finally {
      setIsSubmittingContact(false);
    }
  };

  const handleBookingSubmit = async (e) => {
    e.preventDefault();
    setIsSubmittingBooking(true);
    
    try {
      // Format data for backend API
      const bookingData = {
        name: bookingForm.name,
        email: bookingForm.email,
        phone: bookingForm.phone,
        date: bookingForm.preferredDay,
        time: bookingForm.preferredTime,
        service: bookingForm.disputeType || 'General consultation',
        message: `Company: ${bookingForm.company || 'N/A'}. Alternative slots: ${bookingForm.alternativeSlots || 'N/A'}. Additional message: ${bookingForm.message || 'N/A'}`
      };
      
      const response = await fetch(`${API_URL}/api/booking`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(bookingData)
      });
      
      if (!response.ok) {
        throw new Error('Failed to submit booking');
      }
      
      const data = await response.json();
      toast.success(t.toast.bookingSuccess);
      setBookingForm({
        name: '',
        email: '',
        phone: '',
        company: '',
        disputeType: '',
        preferredDay: '',
        preferredTime: '',
        alternativeSlots: '',
        message: ''
      });
    } catch (error) {
      toast.error(t.toast.error);
    } finally {
      setIsSubmittingBooking(false);
    }
  };

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Header 
        language={language}
        changeLanguage={changeLanguage}
        t={t}
        scrollToSection={scrollToSection}
      />

      <Hero t={t} scrollToSection={scrollToSection} />

      <About t={t} />

      <Services t={t} />

      <Team t={t} />

      <FAQ t={t} />

      <Booking
        t={t}
        bookingForm={bookingForm}
        setBookingForm={setBookingForm}
        handleBookingSubmit={handleBookingSubmit}
        isSubmittingBooking={isSubmittingBooking}
      />

      <Contact
        t={t}
        contactForm={contactForm}
        setContactForm={setContactForm}
        handleContactSubmit={handleContactSubmit}
        isSubmittingContact={isSubmittingContact}
      />

      <Footer t={t} scrollToSection={scrollToSection} />

      <WhatsAppButton language={language} />
    </div>
  );
};

export default Home;
